import { render, staticRenderFns } from "./product-aside.vue?vue&type=template&id=4179446b&"
import script from "./product-aside.vue?vue&type=script&lang=js&"
export * from "./product-aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports